import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class TimeInputComponent {
  @Input()
  appearance?: 'fill' | 'outline' = 'outline';
  
  @Input()
  label: string = '';

  @Input()
  name: string = '';

  @Input()
  icon?: string = '';

  constructor() {}
}
